//new start for only otp login -- 09-05-2025
// frontend/src/components/Signup.js

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/auth.css';
import { countries, states, districts } from '../data/locationData';
import { FaUserAlt, FaUserTie } from 'react-icons/fa';
import SocialLogin from './SocialLogin';
import TermsAgreement from './TermsAgreement';
import loginWelcomeImage from '../images/login-welcome.png';

const Login = () => {
  const [activePartition, setActivePartition] = useState('Public');
  const navigate = useNavigate();

 

  // OTP state
  const [emailOtpState, setEmailOtpState] = useState({
    email: '',
    otp: '',
    verified: false,
    type: 'public', // set default to 'public'
  });

  const [otpPopupOpen, setOtpPopupOpen] = useState(false);
  const [blockedPopupOpen, setBlockedPopupOpen] = useState(false);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(true); // Default to true as per user request

  const [publicUserData, setPublicUserData] = useState({
    firstName: '', lastName: '', age: '', state: '', country: '', district: '',
    email: '', phone: '', password: '', profilePhoto: null,
  });

  const [legalAdvisorData, setLegalAdvisorData] = useState({
    firstName: '', lastName: '', email: '', phone: '', barCouncilNumber: '',
    specialization: '', experience: '', password: '', country: '', state: '',
    district: '', profilePhoto: null,
  });

  // Sync OTP type with tab
  useEffect(() => {
    setEmailOtpState(prev => ({ ...prev, type: activePartition === 'Public' ? 'public' : 'legal' }));
  }, [activePartition]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) navigate('/services');
  }, [navigate]);

  const handlePublicChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'profilePhoto') {
      setPublicUserData(prev => ({ ...prev, profilePhoto: files[0] }));
    } else if (name === 'country') {
      setPublicUserData(prev => ({ ...prev, [name]: value, state: '', district: '' }));
    } else if (name === 'state') {
      setPublicUserData(prev => ({ ...prev, [name]: value, district: '' }));
    } else {
      setPublicUserData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleLegalChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'profilePhoto') {
      setLegalAdvisorData(prev => ({ ...prev, profilePhoto: files[0] }));
    } else if (name === 'country') {
      setLegalAdvisorData(prev => ({ ...prev, [name]: value, state: '', district: '' }));
    } else if (name === 'state') {
      setLegalAdvisorData(prev => ({ ...prev, [name]: value, district: '' }));
    } else {
      setLegalAdvisorData(prev => ({ ...prev, [name]: value }));
    }
  };

  const sendOtp = async (type) => {
    const email = type === 'public' ? publicUserData.email : legalAdvisorData.email;
    if (!email) return toast.error('Enter your email address');
    
    if (!termsAccepted) {
      return toast.error('Please agree to the Terms of Service and Privacy Policy to continue');
    }

    try {
      setSendingOtp(true);
      
      // First check if user exists and is blocked (but don't login directly)
      try {
        const checkRes = await axios.get(`/api/auth/check-user-exists?email=${email}`);
        if (checkRes.data.exists) {
          // User exists, check if blocked
          // Don't login directly, proceed with OTP flow
        }
      } catch (checkErr) {
        if (checkErr.response?.status === 403 && checkErr.response?.data?.blocked) {
          setBlockedPopupOpen(true);
          return;
        }
        // If it's not a blocked user error, continue with OTP flow
      }

      // Always send OTP for all users (both new and existing)
      const res = await axios.post('/api/auth/send-email-otp', { email });
      toast.success(res.data.msg || 'OTP sent to email!');
      setEmailOtpState({ email, otp: '', verified: false, type });
      setOtpPopupOpen(true);
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Failed to send OTP');
    } finally {
      setSendingOtp(false);
    }
  };

  const verifyOtp = async () => {
    try {
      const res = await axios.post('/api/auth/verify-email-otp', {
        email: emailOtpState.email,
        otp: emailOtpState.otp,
      });

      if (res.data.success) {
        toast.success('OTP verified!');
        
        // New user - proceed with signup flow
        setEmailOtpState(prev => ({ ...prev, verified: true }));
        const email = emailOtpState.email;

        // After OTP verification, check if user exists to login or signup
        try {
          const checkRes = await axios.get(`/api/auth/check-user-exists?email=${email}`);
          if (checkRes.data.exists) {
            // Existing user - login directly after OTP verification
            localStorage.setItem('token', checkRes.data.token);
            toast.success('Welcome back!');
            window.location.href = '/';
            return;
          }
        } catch (checkErr) {
          if (checkErr.response?.status === 403 && checkErr.response?.data?.blocked) {
            setBlockedPopupOpen(true);
            return;
          }
          // If error, continue with signup flow
        }

        if (emailOtpState.type === 'public') {
          setPublicUserData(prev => ({ ...prev, email }));
        } else {
          setLegalAdvisorData(prev => ({ ...prev, email }));
        }

        setOtpPopupOpen(false);
      } else {
        toast.error('Invalid OTP');
      }
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Verification failed');
    }
  };

  const handlePublicSignup = async () => {
    try {
      const formData = new FormData();
      Object.entries(publicUserData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const res = await axios.post('/api/auth/signup', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      localStorage.setItem('token', res.data.token);
      toast.success('Welcome to G_Lawhub');
      window.location.href = '/services';
    } catch (err) {
      toast.error(err.response?.data?.msg || 'Please fill in required fields');
    }
  };

  const handleSocialLoginSuccess = (data) => {
    // This will be called when social login is successful
    // console.log('Social login successful:', data); // Disabled for security
    
    // If it's a new user, pre-fill the form with social media data
    if (data.isNewUser) {
      // Pre-fill the public user data with social media information
      setPublicUserData(prev => ({
        ...prev,
        firstName: data.user?.firstName || '',
        lastName: data.user?.lastName || '',
        email: data.user?.emailOrPhone || '',
        // Leave other fields empty for user to complete
        age: '',
        state: '',
        country: '',
        district: '',
        phone: '',
        profilePhoto: null
      }));

      // Set the active partition to Public and mark OTP as verified
      setActivePartition('Public');
      setEmailOtpState(prev => ({
        ...prev,
        email: data.user?.emailOrPhone || '',
        verified: true,
        type: 'public'
      }));

      // Set flag for profile update popup
      localStorage.setItem('showProfileUpdatePopup', 'true');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-content">
        {/* Welcome Image Side */}
        <div className="auth-image-side">
          <img src={loginWelcomeImage} alt="Welcome to G-Law" className="welcome-image" />
        </div>

        {/* Form Side */}
        <div className="auth-form-side">
      {/* <div className="sign-partition-bar">
      
        <button className={activePartition === 'Public' ? 'active' : ''} onClick={() => setActivePartition('Public')}>Public</button>
       <button  className={activePartition === 'Legal Advisors' ? 'active' : ''} onClick={() => setActivePartition('Legal Advisors')}>Legal Advisors</button>
      </div> */}

{/* <div className="sign-partition-bar">
  <button
    className={activePartition === 'Public' ? 'active' : ''}
    onClick={() => setActivePartition('Public')}
  >
    <FaUserAlt style={{ marginRight: '8px' }} />
    Public
  </button>

  <button
    className={activePartition === 'Legal Advisors' ? 'active' : ''}
    onClick={() => setActivePartition('Legal Advisors')}
  >
    <FaUserTie style={{ marginRight: '8px' }} />
    Legal Advisors
  </button>
</div> */}


             {/* OTP Input Gate */}
 {!emailOtpState.verified && (
   <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
     <h2 className="login-heading">Join Us</h2>

    {/* Email input and OTP button in same row */}
    <div className="email-otp-row">
      <input
        type="email"
        placeholder="Enter your email"
        className="email-input-inline"
        value={activePartition === 'Public' ? publicUserData.email : legalAdvisorData.email}
        onChange={(e) => {
          const val = e.target.value;
          if (activePartition === 'Public') {
            setPublicUserData(prev => ({ ...prev, email: val }));
          } else {
            setLegalAdvisorData(prev => ({ ...prev, email: val }));
          }
        }}
      />
      
      <button
        type="button"
        className={`otp-button-inline ${!termsAccepted ? 'disabled-button' : ''}`}
        onClick={() => sendOtp(activePartition === 'Public' ? 'public' : 'legal')}
        disabled={sendingOtp || !termsAccepted}
      >
        {sendingOtp ? 'Sending...' : 'Get OTP'}
      </button>
    </div>

    {/* Social Login Section */}
    <SocialLogin 
      onLoginSuccess={handleSocialLoginSuccess} 
      termsAccepted={termsAccepted}
      onBlockedUser={() => setBlockedPopupOpen(true)}
    />

    {/* Terms and Privacy Policy Agreement - Moved to bottom as per sketch */}
    <TermsAgreement
      isChecked={termsAccepted}
      onChange={(e) => setTermsAccepted(e.target.checked)}
      checkboxId="login-terms-agreement"
      className="login-style"
    />
  </form>
 )}

             {/* Public Signup Form */}
       {activePartition === 'Public' && emailOtpState.verified && emailOtpState.type === 'public' && (
         <form className="auth-form" onSubmit={(e) => e.preventDefault()}>
           <h2>My Profile</h2>
           <input name="firstName" placeholder="First Name" value={publicUserData.firstName} onChange={handlePublicChange} />
           <input name="lastName" placeholder="Last Name" value={publicUserData.lastName} onChange={handlePublicChange} />
           <input name="age" type="number" placeholder="Age" value={publicUserData.age} onChange={handlePublicChange} />
           <select name="country" value={publicUserData.country} onChange={handlePublicChange}>
             <option value="">Select Country</option>
             {countries.map((c) => <option key={c} value={c}>{c}</option>)}
           </select>
           <select name="state" value={publicUserData.state} onChange={handlePublicChange}>
             <option value="">Select State</option>
             {states[publicUserData.country]?.map((s) => <option key={s} value={s}>{s}</option>)}
           </select>
           <select name="district" value={publicUserData.district} onChange={handlePublicChange}>
             <option value="">Select District (Optional)</option>
             {districts[publicUserData.state]?.map((d) => <option key={d} value={d}>{d}</option>)}
           </select>
           
           <input name="phone" placeholder="Phone Number" value={publicUserData.phone} onChange={handlePublicChange} />

           <input type="email" value={publicUserData.email} disabled />
           {/* <input type="file"name="profilePhoto" accept="image/*" onChange={handlePublicChange} /> */}
           
     <label>
       Profile Photo (optional):
       <input type="file" name="profilePhoto" accept="image/*" onChange={handlePublicChange} />
     </label>
           {publicUserData.profilePhoto && (
             <img src={URL.createObjectURL(publicUserData.profilePhoto)} alt="Preview" width="100" style={{ borderRadius: '8px' }} />
             
           )}
           {/* <input type="password" name="password" placeholder="Password" value={publicUserData.password} onChange={handlePublicChange} /> */}
          

           <button type="button" onClick={handlePublicSignup}>Update</button>
         </form>
       )}

      {/* ✅ OTP POPUP */}
      {otpPopupOpen && (
        <div className="otp-popup">
          <div className="otp-popup-content">
            <h3>Enter OTP</h3>
            <input
              type="text"
              placeholder="Enter OTP"
              value={emailOtpState.otp}
              onChange={(e) => setEmailOtpState(prev => ({ ...prev, otp: e.target.value }))}
            />
            <button onClick={verifyOtp}>Verify OTP</button>
          </div>
        </div>
      )}
      
      <ToastContainer />
        </div>
      </div>
    </div>
  );
};

export default Login;